export const heroData = {
  title: "Getting to the Helipad",
  subtitle: "Our Yokohama helipad is easily accessible by train, car, or taxi.",
  image:
    "https://readdy.ai/api/search-image?query=Modern%20helipad%20facility%20entrance%20with%20clean%20architectural%20design%2C%20warm%20sunset%20lighting%2C%20luxury%20transportation%20hub%2C%20deep%20navy%20sky%20gradient%2C%20professional%20and%20welcoming%20atmosphere%2C%20editorial%20photography%2C%20no%20text%2C%20high%20quality&width=1920&height=600&seq=accesshero01&orientation=landscape",
};

export const accessInfo = {
  label: "ACCESS",
  title: "Access Information",
  address: {
    label: "Address",
    value: "[Address details coming soon]",
  },
  methods: [
    {
      type: "train",
      title: "By Train",
      desc: "You can take a taxi or walk from the nearest station. Detailed directions will be provided after your reservation is confirmed.",
    },
    {
      type: "car",
      title: "By Car",
      desc: "Parking is available near the helipad, but spaces are limited. Please let us know at the time of booking if you plan to drive.",
    },
    {
      type: "taxi",
      title: "By Taxi",
      desc: "Approximately 5–10 minutes by taxi from the nearest station. A pick-up service is also available as an optional add-on.",
    },
  ],
};

export const mapNote = {
  label: "MAP",
  title: "Area Map",
  description:
    "A map of the helipad area is being prepared. Detailed access information will be sent to you after your reservation is confirmed.",
};

export const tipsData = {
  label: "TIPS",
  title: "Access Tips",
  items: [
    "Please arrive at least 30 minutes before your scheduled boarding time.",
    "The helipad is an outdoor facility. Please bring an umbrella on rainy days.",
    "Parking is available by prior reservation. Please request this at the time of booking.",
    "If you are running late, please call us immediately.",
    "The helipad is located in a residential area. Please be considerate of local residents.",
  ],
};

export const finalCTA = {
  title: "Detailed access info will\nbe provided at booking",
  subtitle: "Feel free to contact us if you have any questions",
  ctas: [
    { label: "Inquire About Booking", href: "/contact", type: "primary" },
  ],
};
